<template>
  <div class="rightBanner" @mouseleave="leave" @mouseenter="mouse">
    <ul class="banner">
      <li :class="{cls:data.cls}" v-for="(data,index) in tlbannerimg" :key="index">
        <img :src="data.url" alt />
      </li>
    </ul>
    <ul class="banNav">
      <li
        @click="clibaner(index)"
        :class="{cls:num.cls}"
        v-for="(num,index) in tlbannerNav"
        :key="index"
      >{{num.num}}</li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loa: false,
      tlbannerimg: [
        {
          url: require("../assets/image/worksrbanner_img20021101.jpg?1"),
          cls: true
        },
        {
          url: require("../assets/image/worksrbanner_img20021102.jpg?1"),
          cls: false
        },
        {
          url: require("../assets/image/worksrbanner_img20021103.jpg?23"),
          cls: false
        },
        {
          url: require("../assets/image/worksrbanner_img20021104.jpg"),
          cls: false
        }
      ],
      tlbannerNav: [
        { num: "1", cls: true },
        { num: "2", cls: false },
        { num: "3", cls: false },
        { num: "4", cls: false }
      ],
      timer: null,
      index: null,
      time: 1000
    };
  },
  created() {
    let index = 0;
    const tlblenght = this.tlbannerimg.length - 1;
    this.timer = setInterval(() => {
      if (index == tlblenght) {
        index = 0;
        this.automatic(index);
        return;
      } else {
        index++;
        this.automatic(index);
      }
    }, this.time);
  },
  methods: {
    // 自动轮播
    automatic(index) {
      for (let key in this.tlbannerimg) {
        this.tlbannerimg[key].cls = false;
        this.tlbannerNav[key].cls = false;
      }
      // console.log(this.num);
      this.tlbannerimg[index].cls = true;
      this.tlbannerNav[index].cls = true;
    },
    load() {
      this.loa = !this.loa;
      setTimeout(() => {
        this.loa = !this.loa;
        this.$message({
          showClose: true,
          message: "没有更多了！"
        });
      }, 500);
    },
    // 点击轮播
    clibaner(index) {
      // console.log(index);
      for (let key in this.tlbannerNav) {
        this.tlbannerNav[key].cls = false;
        this.tlbannerimg[key].cls = false;
      }
      this.tlbannerNav[index].cls = true;
      this.tlbannerimg[index].cls = true;
      this.index = index;
    },
    // 划入暂停轮播
    mouse() {
      clearInterval(this.timer);
      this.timer = null;
      const index = this.tlbannerimg.findIndex(todo => {
        return todo.cls == true;
      });
      this.index = index;
    },
    leave() {
      var index = this.index;
      console.log(index);
      const tlblenght = this.tlbannerimg.length - 1;
      this.timer = setInterval(() => {
        if (index == tlblenght) {
          index = 0;
          this.automatic(index);
          return;
        } else {
          index++;
          this.automatic(index);
        }
      }, this.time);
    }
  }
};
</script>
<style scoped>
.rightBanner {
  position: relative;
  float: right;
  width: 364px;
  height: 100%;
  overflow: hidden;
}
.rightBanner .banner,
.rightBanner .banner li {
  float: left;
  width: 100%;
  height: 100%;
}
.rightBanner .banner li.cls {
  display: block;
}
.rightBanner .banner li {
  position: relative;
  display: none;
}
.rightBanner .banner li img {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 100%;
  transform: translate(-50%, -50%);
}
.rightBanner .banNav {
  position: absolute;
  right: 10px;
  bottom: 10px;
}
.rightBanner .banNav li {
  float: left;
  width: 23px;
  height: 23px;
  text-align: center;
  line-height: 23px;
  font-size: 14px;
  color: #000;
  background: #fff;
  margin-right: 4px;
  cursor: pointer;
}
.rightBanner .banNav li.cls {
  background: #bfa75d;
}
.rightBanner .banNav li:last-child() {
  margin: 0;
}
</style>